import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { BillingInformationService, ResetBillingAddresses, SetBillingAddresses } from '@platform-frontend/marketplace';
import { RefreshWindow } from '@platform-frontend/util';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { FetchFlowData, FlowCanceled, PublishFetchedFlowData, SetFlow } from '../flow/flow.actions';
import { CheckoutBillingInformationStateModel } from './model/checkout-billing-information-state-model';

const DEFAULT_STATE: CheckoutBillingInformationStateModel = {
  loadedBillingAddresses: [],
  loadedAccountingEmail: null
};

@State<CheckoutBillingInformationStateModel>({
  name: 'checkoutBillingInformation',
  defaults: DEFAULT_STATE
})
@Injectable()
export class CheckoutBillingInformationState {
  constructor(private billingInformationService: BillingInformationService) {}

  @Action(FetchFlowData)
  loadBillingAddresses(ctx: StateContext<CheckoutBillingInformationStateModel>, { flow }: FetchFlowData): Observable<unknown> {
    if (flow.type !== 'COMMERCIAL_CHECKOUT' && flow.type !== 'SUBSCRIPTION_MANAGEMENT') {
      return of(null);
    }

    return this.billingInformationService
      .fetchBillingAddresses(flow.startParams.contractId)
      .pipe(
        tap(({ billingAddresses, accountingEmail }) => ctx.patchState({ loadedBillingAddresses: billingAddresses, loadedAccountingEmail: accountingEmail }))
      );
  }

  @Action(PublishFetchedFlowData)
  publishBillingAddresses(ctx: StateContext<CheckoutBillingInformationStateModel>): Observable<unknown> {
    const { loadedBillingAddresses, loadedAccountingEmail } = ctx.getState();
    ctx.setState(DEFAULT_STATE);
    return ctx.dispatch(new SetBillingAddresses({ billingAddresses: loadedBillingAddresses, accountingEmail: loadedAccountingEmail }));
  }

  @Action(SetFlow)
  @Action(RefreshWindow)
  @Action(FlowCanceled)
  flowCanceled(ctx: StateContext<CheckoutBillingInformationStateModel>): Observable<unknown> {
    ctx.setState(DEFAULT_STATE);
    return ctx.dispatch(new ResetBillingAddresses());
  }
}
